import { PropsWithChildren } from "react";

import useDialogStore from "@store/useDialogStore";
import { useEscapeKey } from "@hooks/useEscapeKey";
import { BaseDialog } from "@ui/Dialogs/BaseDialog";

interface IConfirmDeleteDialogProps extends PropsWithChildren {
  title: string;
  onSubmit: VoidFunction;
  onCancel?: VoidFunction;
  submitButtonTitle?: string;
  cancelButtonTitle?: string;
}

export function ConfirmDeleteDialog({
  title,
  onSubmit,
  onCancel,
  submitButtonTitle,
  cancelButtonTitle,
  children,
}: IConfirmDeleteDialogProps) {
  const { isOpen, closeDialog } = useDialogStore();

  const handleDialogClose = () => closeDialog();

  useEscapeKey({ callback: closeDialog, enabled: isOpen });

  return (
    <BaseDialog
      key={title}
      title={title}
      titleClassName={"text-base justify-center"}
      showCloseButton={false}
      primaryButton={{
        label: submitButtonTitle ?? "Remove",
        callback: onSubmit,
      }}
      secondaryButton={{
        label: cancelButtonTitle ?? "Cancel",
        buttonTypeOverride: "CANCEL",
        callback: () => {
          handleDialogClose();
          onCancel?.();
        },
      }}
    >
      {children}
    </BaseDialog>
  );
}
